<template>
  <div class="vue timparty-band-party-collection band-party-collection">

    <div class="band-party-collection" v-if="contest_ready">
      <div class="row">
        <div class="col-lg-6 p-0">
          <img :src="contest_image" alt="" class="w-100">
        </div>
        <div class="col-lg-6 p-4 p-md-0">
          <div class="half-container p-3 p-md-5">
            <h2 class="section-title my-3">Party Moments</h2>
            <p class="section-content">
              Scopri i nuovi vantaggi Party Moments.
              <br>
              Vivi i tuoi momenti speciali con TIM Party.
              <br>
              Approfitta dei vantaggi 2x1 per vivere fantastiche esperienze a metà prezzo scegliendo tra oltre 1200 strutture in tutta Italia.
            </p>
            <a :href="contest_url" class="btn btn-lg btn-white mt-3 cta-generic">Scopri di più</a>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

/* eslint-disable */

import moment        from "moment";
import TimPartyMixin from '../mixins/TimPartyMixin';

export default {
  name: 'BandPartyMoments',
  mixins: [ TimPartyMixin ],
  data: function(){
    return {

      current_contest: {},
      contest_ready: false,

    };
  },
  props: {

    image: {
      type: String,

    },
    url: {
      type: String,
      default: '/geo/vantaggi',
    },

    endDate: {
      type: String,
      default: '20221122' // YYYYMMDD,
    }
  },
  mounted: function(){

    if( this.user.id )
      this.getContest();

  },

  methods: {
    getContest: function( ){
      let self = this;

      if( !this.user.endpoints.contest ) {
        return false;
      }

      if( !this.user.party_collection_current_code ) {
        return false;
      }
      let url = new URL(window.location.href);

      let endDateString = url.searchParams.has('endDate') ? url.searchParams.get('endDate') : self.endDate;

      // Party moments off part 1 at 2022-12-01
      // Party moments off part 2 at 2023-01-01
      let endDate = moment(endDateString, 'YYYYMMDD')
      endDate.hour(23).minute(59).second(59);
      let today = moment();

      if(today.isAfter(endDate)) {
        return false;
      }

      this.setApiUrl( this.user.endpoints.contest );

      var payload = {
        action: 'get',
        access_token: this.access_token,
        contest_code: this.user.party_collection_current_code,

      };

      this.loading = true;

      this.callApiGet( payload, function( response){
        self.loading = false;
        self.current_contest = response.data;

        self.contest_ready = true;

      } );

    }
  },


  watch: {
    user: function(new_val){
      this.getContest();
    },
    end_date: function (){
      this.getContest();
    }
  },

  computed: {
    contest_url: function(){
      if( this.url ){
        return this.url;
      } else{
        return '/geo/vantaggi';
      }
    },

    contest_image: function(){
      if( this.image ){
        return this.image;
      } else{
        return this.modulePath('/js/src/assets/images/partymoments.png');
      }
    },
  }


}
</script>


